import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Values from './components/Values';
import Clients from './components/Clients';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <div className="min-h-screen bg-light">
      <Header />
      <div className="pt-32 md:pt-28"> {/* Updated padding: taller on mobile due to stacked header */}
        <Hero />
        <Services />
        <Values />
        <Clients />
        <Gallery />
        <Contact />
      </div>
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;